module.exports = __webpack_public_path__ + "img/electronic_electric_enabled_selected.a5908a15.svg";